export const SHOPIFY_LINKS = {
  memorisation: "https://samnara.myshopify.com/products/memorisation-du-coran-en-6-mois",
  revision: "https://samnara.myshopify.com/products/revision-du-coran-en-30-jours",
  "pack-complet": "https://samnara.myshopify.com/products/pack-gold-memorisation-revision-du-coran",
};

// Ajoute au panier puis ouvre la page panier pour vérification avant paiement
export const SHOPIFY_CHECKOUT = {
  memorisation: "https://samnara.myshopify.com/cart/add?id=56240438804865&quantity=1",
  revision: "https://samnara.myshopify.com/cart/add?id=56245827699073&quantity=1",
  "pack-complet": "https://samnara.myshopify.com/cart/add?id=56253607051649&quantity=1",
};
